import { render, staticRenderFns } from "./Create-Adjustment.vue?vue&type=template&id=d2e4f910&scoped=true"
import script from "./Create-Adjustment.vue?vue&type=script&lang=js"
export * from "./Create-Adjustment.vue?vue&type=script&lang=js"
import style0 from "./Create-Adjustment.vue?vue&type=style&index=0&id=d2e4f910&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2e4f910",
  null
  
)

export default component.exports